import {ApiClientCommunication} from 'neo-common';
import {IProgressiveBonusLevel} from '../Types/IProgressiveBonusLevel';

export class ProgressiveBonusGetInfoResponse extends ApiClientCommunication.ResponseBase {

    /**
     * @property Three letter currency code as defined in ISO 4217.
     */
    currency: string;

    /**
     * @property Denomination of 1 credit..
     */
    denomination: number;

    /**
     * @property Current date and time of server. Used to synchronize time.
     */
    timestamp: string;

    /**
     * @property Interval for refreshing bonus levels and other info (in seconds).
     */
    refreshInterval: number;

    /**
     * @property Specifies levels of progressive bonus.
     */
    levels: Array<IProgressiveBonusLevel>;

    /**
     * @property Contains information about bonus ticket, if available.
     */
    ticket: {
        /**
         * @property Bonus ticket identifier.
         */
        id: number;
    };


    protected internalValidate(errors: Array<string>): void {
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Responses/ProgressiveBonusGetInfoResponse.ts
 **/